import styled from 'styled-components';
import { colors } from '../../config/styles';
import { UnsupportedUrl } from './types';

interface IProps {
  parsedUrl: UnsupportedUrl;
}

const Error = styled.div`
  color: ${colors.warningRed};
`;

export const UnsupportedEmbed = ({ parsedUrl }: IProps) => {
  return (
    <Error>
      The specified media URL cannot be embedded:{' '}
      <a
        href={parsedUrl.url}
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        {parsedUrl.url}
      </a>
    </Error>
  );
};
